export default __webpack_public_path__ + "images/gw_mono_0_0.png?4026e396f5396be0f93164e50ee5bb21";